var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"campaign"},[_c('Header',{attrs:{"user":_vm.user}}),_c('main',{staticClass:"main",class:{ 'expand-main' : _vm.isMenuCollapse }},[_c(_vm.campaignsTabComponent,{tag:"component",attrs:{"selectedCampaignId":_vm.selectedCampaignId,"selectedCampaignName":_vm.selectedCampaignName,"filter":_vm.filter}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }